
import React from 'react';
import { ArrowLeft, Trash2, Eye } from 'lucide-react';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { Button } from '@/components/ui/button';
import { Profile } from '@/components/messages/types';

interface ChatHeaderProps {
  otherUserProfile: Profile | null;
  currentListing: { id: number; title?: string } | null;
  handleBackToList: () => void;
  handleDeleteChat: (chatId: number) => void;
  selectedChatId: number;
  handleViewListing: (listingId: number | undefined) => void;
}

const ChatHeader: React.FC<ChatHeaderProps> = ({
  otherUserProfile,
  currentListing,
  handleBackToList,
  handleDeleteChat,
  selectedChatId,
  handleViewListing,
}) => {
  const userName = otherUserProfile?.full_name || otherUserProfile?.username || 'Përdorues i Panjohur';
  const userInitial = (userName.charAt(0) || 'U').toUpperCase();

  return (
    <div className="p-2 md:p-3 border-b border-gray-200 dark:border-gray-700 flex items-center justify-between">
      <div className="flex items-center space-x-2 md:space-x-3">
        <Button
          variant="ghost"
          size="icon"
          className="md:hidden text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700"
          onClick={handleBackToList}
          aria-label="Kthehu te lista e bisedave"
        >
          <ArrowLeft className="h-6 w-6 md:h-5 md:w-5" /> {/* Adjusted icon size for mobile touch */}
        </Button>
        
        <Avatar className="h-8 w-8 md:h-10 md:w-10"> {/* Adjusted avatar size for mobile */}
          <AvatarImage src={otherUserProfile?.profile_image || ''} alt={userName} />
          <AvatarFallback className="bg-gray-200 dark:bg-gray-600 text-gray-700 dark:text-gray-200">
            {userInitial}
          </AvatarFallback>
        </Avatar>
        
        <div className="flex flex-col min-w-0"> {/* Added min-w-0 for truncation */}
          <p className="font-semibold text-gray-900 dark:text-gray-100 text-sm md:text-base truncate">{userName}</p> {/* Increased font weight and base size */}
          {currentListing?.title && (
            <span 
              className="text-xs text-gray-500 dark:text-gray-400 hover:underline cursor-pointer truncate"
              onClick={() => handleViewListing(currentListing?.id)}
              title={`Shiko shpalljen: ${currentListing.title}`}
            >
              Re: {currentListing.title}
            </span>
          )}
        </div>
      </div>
      
      <div className="flex items-center space-x-1"> {/* Reduced space for mobile */}
        {currentListing && (
          <Button
            variant="ghost"
            size="icon"
            className="text-gray-500 dark:text-gray-400 hover:text-brand-500 dark:hover:text-brand-400 p-1.5 md:p-2" // Adjusted padding
            onClick={() => handleViewListing(currentListing.id)}
            aria-label="Shiko shpalljen"
            title="Shiko shpalljen"
          >
            <Eye className="h-5 w-5" />
          </Button>
        )}
        <Button
          variant="ghost"
          size="icon"
          className="text-gray-500 dark:text-gray-400 hover:text-red-500 dark:hover:text-red-400 p-1.5 md:p-2" // Adjusted padding
          onClick={() => handleDeleteChat(selectedChatId)}
          aria-label="Fshij bisedën"
          title="Fshij bisedën"
        >
          <Trash2 className="h-5 w-5" />
        </Button>
      </div>
    </div>
  );
};

export default ChatHeader;
